<template>
  <!-- Screenshots start -->
  <section v-if="screenshots.length > 0 && template != '-1'" class="content-section screenshots-section mb-3" :class="`template-order-${template}`">

    <h4 class="product-details-subtitle">Product Images</h4>
    <Carousel
      :navigation="screenshots.length > 1 ? true : false"
      :pagination="screenshots.length > 1 ? true : false"
      :startAutoPlay="false"
      :timeout="5000"
      :slideCount="screenshots.length"
      class="carousel"

      v-slot="{ currentSlide }"
    >
    <Slide v-for="(slide, index) in screenshots" :key="index">
        <div v-show="currentSlide === index + 1" class="slide-info" style="z-index: 50;">
          <span v-if="slide.url && isImage(slide.url)">
            <img @click="openModal(slide.url)"  :src="slide.url" :alt="slide.alt" width="500px" class="screenshot-video-height clickable" />
          </span>
          <iframe v-else-if="isYoutube(slide.video_url)" :src="youtubeEmbedUrl(slide.video_url)" frameborder="0" allowfullscreen width="100%" class="screenshot-video-height"></iframe>
          <iframe v-else-if="isVimeo(slide.video_url)" :src="vimeoEmbedUrl(slide.video_url)" frameborder="0" allowfullscreen width="100%" class="screenshot-video-height"></iframe>
          <iframe v-else-if="isWistia(slide.video_url)" :src="wistiaEmbedUrl(slide.video_url)" frameborder="0" allowfullscreen width="100%" class="screenshot-video-height"></iframe>
          <iframe v-else-if="isVidyard(slide.video_url)" :src="vidyardEmbedUrl(slide.video_url)" frameborder="0" allowfullscreen width="100%" class="screenshot-video-height"></iframe>
        </div>
      </Slide>
    </Carousel>
    <ImageModal :open="isModalOpen" :image-url="modalImgUrl" @open-modal="openModal"></ImageModal>
  </section>
  <!-- Screenshots end -->
</template>

<script>
import Carousel from "../animations/Carousel.vue";
import Slide from "../animations/Slide.vue";
import ImageModal from "../animations/ImageModal.vue";
import { ref } from 'vue';

export default {
  props: {
    screenshots: {
      type: Array,
      default: []
    },
    template: {
      type: Number,
      default: 0
    }
  },
  components: {
    Carousel,
    Slide,
    ImageModal
  },
  setup(props) {
    let isModalOpen = ref(false);
    let modalImgUrl = ref("");
    function isImage(url) {
      return /\.(gif|jpe?g|tiff?|png|webp|bmp)$/i.test(url) || url.indexOf('assets.partnerfleet.app') > -1;
    }
    function isYoutube(url) {
      return /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/i.test(url);
    }
    function isVimeo(url) {
      return /^(https?:\/\/)?(www\.)?vimeo\.com\/\d{0,10}$/i.test(url);
    }
    function isWistia(url) {
      return /(\.)?wistia\.(net|com)\/(?:medias|embed)\/.+$/i.test(url);
    }
    function isVidyard(url) {
      return /^(https?:\/\/)?(www\.)?(share\.)?vidyard\.com\/watch\/.+$/i.test(url);
    }
    function youtubeEmbedUrl(url) {
      if (isYoutube(url)) {
        let videoId = ''
        if(url.includes('v=')) {
          videoId = url.split('v=')[1].split('&')[0];
        } else {
          videoId = url.split('be/')[1].split('&')[0];
        }
        return `https://www.youtube.com/embed/${videoId}`;
      }
      return '';
    }
    function vimeoEmbedUrl(url) {
      if (isVimeo(url)) {
        const videoId = url.split('vimeo.com/')[1];
        return `https://player.vimeo.com/video/${videoId}`;
      }
      return '';
    }
    function vidyardEmbedUrl(url) {
      if (isVidyard(url)) {
        const videoId = url.split('watch/')[1];
        return `https://play.vidyard.com/${videoId}.html`;
      }
      return '';
    }
    function wistiaEmbedUrl(url) {
      if (isWistia(url)) {
        const videoId = url.split(/embed\/|medias\//)[1];
        return `https://fast.wistia.net/embed/iframe/${videoId}`;
      }
      return '';
    }
    function openModal(url) {
      isModalOpen.value = !isModalOpen.value;
      modalImgUrl.value = url;
    } 
    
    return {
      isImage,
      isYoutube,
      isVimeo,
      isWistia,
      isVidyard,
      youtubeEmbedUrl,
      vimeoEmbedUrl,
      wistiaEmbedUrl,
      vidyardEmbedUrl,
      openModal,
      modalImgUrl,
      isModalOpen
    }
  },
}
</script>
